module.exports = __webpack_public_path__ + "static/assets/bd80d0e2ced9fe94099cde558bb0689a.svg";